import Typography from '@mui/material/Typography';
import InfoBannerBlock from '@shared/components/feedback/InfoBannerBlock/InfoBannerBlock';
import PasswordField from '@shared/components/inputs/PasswordField/PasswordField';
import type { SecuritySectionProps } from '@components/Checkout/steps/CustomerInfoStep/CustomerInfoStep.types';

const PASSWORD_BANNER =
  'Your email address and password will be used to access the MyNovus, where you can view your bills, make payments, and manage your account.';

export const SecuritySection = ({ formik, passwordRequirements }: SecuritySectionProps) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } = formik;

  const handleGenerate = () => {
    setFieldTouched('password', false, false);
    setFieldTouched('confirmPassword', false, false);
  };

  return (
    <>
      <Typography variant="heading.subsection" sx={{ lineHeight: '150%' }}>
        Account Security Information
      </Typography>

      <InfoBannerBlock description={PASSWORD_BANNER} />

      <PasswordField
        password={values.password}
        confirmPassword={values.confirmPassword}
        requirements={passwordRequirements}
        onPasswordChange={(v) => setFieldValue('password', v)}
        onConfirmPasswordChange={(v) => setFieldValue('confirmPassword', v)}
        onPasswordBlur={() => setFieldTouched('password', true)}
        onConfirmPasswordBlur={() => setFieldTouched('confirmPassword', true)}
        onGenerate={handleGenerate}
        passwordError={errors.password as string}
        confirmPasswordError={errors.confirmPassword as string}
        passwordTouched={touched.password}
        confirmPasswordTouched={touched.confirmPassword}
      />
    </>
  );
};
